import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as PassportIcon } from '../../assets/images/appicons/appicon-passport.svg';
import { Dialog } from '../shared/dialog/Dialog';
import { Photo } from '../shared/Photo';

export const PassportHintDialog: React.FC = () => {
  const { t } = useTranslation('passport');
  return (
    <Dialog hasHeader={true}>
      <div
        className={css`
          color: #938666;
          text-align: center;
          h1 {
            color: #4d3906;
            font-size: 20px;
            text-align: center;
          }
          p {
            margin: 0 0 8px;
          }
          section {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 12px 0;
          }
          section:last-child {
            padding-bottom: 40px;
          }
          .passport-icon {
            width: 96px;
            height: 96px;
            background: #87c589;
            border-radius: 36%;
            transform: rotate(-4deg);
            margin: 8px 0 32px;
          }
          .photo {
            width: 240px;
            height: 157px;
            position: relative;
            margin: 0 0 16px;
            img {
              object-fit: contain;
            }
          }
          /* less than iPhone6/7/8 display size */
          @media screen and (max-width: 374px) {
            font-size: 14px;
            h1 {
              font-size: 18px;
            }
            .passport-icon {
              width: 88px;
              height: 88px;
            }
            .sec-1 .photo {
              width: 160px;
              height: 106px;
            }
            .photo {
              width: 200px;
              height: 131px;
            }
          }
        `}
      >
        <h1>{t('help')}</h1>
        <section className="sec-1">
          <div className="passport-icon">
            <PassportIcon width="100%" height="100%" />
          </div>
          <p>{t('help_desc_01')}</p>
        </section>
        <section>
          <div className="photo" style={{ transform: 'rotate(2deg)' }}>
            <Photo
              srcSet={`
              /images/passport/img_passport_hint_01-2x.jpg 2x,
              /images/passport/img_passport_hint_01.jpg 1x
              `}
            />
          </div>
          <p>{t('help_desc_02')}</p>
          <p>{t('help_desc_03')}</p>
        </section>
        <section>
          <div className="photo" style={{ transform: 'rotate(-2deg)' }}>
            <Photo
              srcSet={`
              /images/passport/img_passport_hint_02-2x.jpg 2x,
              /images/passport/img_passport_hint_02.jpg 1x
              `}
            />
          </div>
          <p>{t('help_desc_04')}</p>
          <p>{t('help_desc_05')}</p>
        </section>
      </div>
    </Dialog>
  );
};
